import React from "react";
import {
  FormControl,
  FormLabel,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteIcon from "@mui/icons-material/Delete";

const PictureField = ({
  label,
  value,
  onChange,
  onRemovePhoto,
  disabled,
  tfid,
  photoCaptureLabel,
}) => {
  return (
    <FormControl
      component="fieldset"
      margin="normal"
      disabled={disabled}
      sx={{ width: "100%" }}
    >
      <FormLabel
        component="legend"
        sx={{
          color: "#c1cddb",
          ...(disabled && {
            color: "#a7bbcf !important",
          }),
        }}
      >
        {label}
      </FormLabel>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          marginTop: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={(e) => onChange(e.target.files[0])}
            disabled={disabled}
            style={{ display: "none" }}
            id={`camera-input-${tfid}`}
          />

          <label htmlFor={`camera-input-${tfid}`}>
            <IconButton
              component="span"
              disabled={disabled}
              sx={{
                color: "#c1cddb",
                ...(disabled && {
                  color: "gray !important",
                }),
              }}
            >
              <CameraAltIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </label>

          <Typography
            variant="body2"
            sx={{
              color: "#919aa3",
            }}
          >
            {value && value.length > 0
              ? `${value.length} photo(s) captured`
              : "No Photos Captured"}
          </Typography>
        </Box>

        {value && value.length > 0 && (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              flexShrink: 0,
              marginTop: "8px",
            }}
          >
            <Box
              className="photo-scroll-container"
              sx={{
                width: "100%",
                height: "88px",
                overflowX: "auto",
                overflowY: "hidden",
                scrollbarWidth: "thin",
                scrollbarColor: "#c1cddb #2a2a2a",
                "&::-webkit-scrollbar": {
                  height: "8px",
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#2a2a2a",
                  borderRadius: "4px",
                  margin: "2px 0",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c1cddb",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#9aa8b8",
                  },
                },
                "&::-webkit-scrollbar-corner": {
                  backgroundColor: "#2a2a2a",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                  padding: "4px 0",
                  width: "max-content",
                  minWidth: "100%",
                  height: "80px",
                  alignItems: "center",
                }}
              >
                {value.map((photo, index) => {
                  if (
                    !photo ||
                    typeof photo !== "object" ||
                    !photo.name ||
                    !photo.size
                  ) {
                    console.warn("Invalid photo object at index", index, photo);
                    return null;
                  }

                  let photoUrl;
                  try {
                    photoUrl = URL.createObjectURL(photo);
                  } catch (error) {
                    console.error(
                      "Error creating object URL for photo: ",
                      error
                    );
                    return null;
                  }

                  return (
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        flexShrink: 0,
                        width: "80px",
                        height: "80px",
                        minWidth: "80px",
                        minHeight: "80px",
                        border: "1px solid rgba(193, 205, 219, 0.3)",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={photoUrl}
                        alt={`Photo ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                        onError={(e) => {
                          console.error("Error loading photo:", e);
                          e.target.style.display = "none";
                        }}
                      />

                      {!disabled && (
                        <IconButton
                          onClick={() => onRemovePhoto(index)}
                          size="small"
                          sx={{
                            position: "absolute",
                            top: "2px",
                            right: "2px",
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                            color: "white",
                            width: "20px",
                            height: "20px",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.9)",
                            },
                            zIndex: 1,
                          }}
                        >
                          <DeleteIcon sx={{ fontSize: 12 }} />
                        </IconButton>
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </FormControl>
  );
};

export default PictureField;
